/* A/B/C sample-popup logic — extracted from snippets/abc-test-popup.liquid
   (was ~24KB inline on every page). Config arrives via data attributes /
   globals rendered in the snippet markup; script has no Liquid. */
(function() {
  'use strict';

  // ============================================
  // Configuration
  // ============================================
  const CONFIG = {
    cookieName: 'mbur_abc_test_variant',
    cookieExpiry: 30, // days
    testName: 'popup_offer_test_2025',
    popupDelay: 0, // ms before showing popup (immediate)
    variants: {
      A: { name: 'lead_magnet', label: 'Lead Magnet (Samples)' },
      B: { name: 'bogo', label: 'BOGO Offer' },
      C: { name: 'control', label: 'Control (No Popup)' }
    },
    // Internal traffic exclusions
    internalIPs: ['108.6.132.228'],
    bogoDiscountCode: 'BOGO',
    sampleDiscountCode: 'Trysamples'
  };

  // ============================================
  // Utility Functions
  // ============================================
  function getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; SameSite=Lax`;
  }

  // ============================================
  // Internal Traffic Detection
  // ============================================
  async function isInternalTraffic() {
    const urlParams = new URLSearchParams(window.location.search);
    const settings = window.abcTestSettings || {};

    // Allow forced variants to bypass all checks (for testing)
    if (urlParams.get('force_variant')) {
      console.log('[ABC Test] Bypassing internal checks - force_variant present');
      return false;
    }

    // Allow ?force_popup=true to bypass internal checks
    if (urlParams.get('force_popup') === 'true') {
      console.log('[ABC Test] Bypassing internal checks - force_popup=true');
      return false;
    }

    // If "Show to Internal Traffic" is enabled, skip all internal checks
    if (settings.showToInternalTraffic === true) {
      console.log('[ABC Test] Show to internal traffic enabled - bypassing checks');
      return false;
    }

    // Check URL parameter to explicitly mark as internal
    if (urlParams.get('internal') === 'true') {
      console.log('[ABC Test] Skipped: internal URL parameter');
      return true;
    }

    // Check Shopify design mode
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[ABC Test] Skipped: Shopify design mode');
      return true;
    }

    // Check admin referrer
    if (document.referrer.includes('/admin')) {
      console.log('[ABC Test] Skipped: came from admin');
      return true;
    }

    // Check internal IP (async)
    try {
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      if (CONFIG.internalIPs.includes(ipData.ip)) {
        console.log('[ABC Test] Skipped: internal IP');
        return true;
      }
    } catch (e) {
      // Continue if IP check fails
    }

    return false;
  }

  // ============================================
  // GA4 Tracking
  // ============================================
  function trackEvent(eventName, eventParams = {}) {
    if (typeof gtag === 'undefined') {
      console.warn('[ABC Test] gtag not available');
      return;
    }

    const params = {
      test_name: CONFIG.testName,
      ...eventParams
    };

    gtag('event', eventName, params);
    console.log('[ABC Test] Tracked:', eventName, params);
  }

  // ============================================
  // Variant Assignment
  // ============================================
  function assignVariant() {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for forced variant (testing only)
    const forcedVariant = urlParams.get('force_variant');
    if (forcedVariant && ['A', 'B', 'C'].includes(forcedVariant.toUpperCase())) {
      const variant = forcedVariant.toUpperCase();
      console.log('[ABC Test] FORCED variant:', variant);
      // Don't save to cookie when forcing, so each test is fresh
      return variant;
    }

    // Check popup mode from theme settings
    const settings = window.abcTestSettings || {};
    const popupMode = settings.popupMode || 'ab_test';

    // If not A/B test mode, return the specific variant
    if (popupMode === 'lead_magnet') {
      console.log('[ABC Test] Mode: Lead Magnet only');
      return 'A';
    } else if (popupMode === 'bogo') {
      console.log('[ABC Test] Mode: BOGO only');
      return 'B';
    }

    // A/B Test mode - check for existing assignment
    const existingVariant = getCookie(CONFIG.cookieName);
    if (existingVariant && ['A', 'B'].includes(existingVariant)) {
      console.log('[ABC Test] Existing variant:', existingVariant);
      return existingVariant;
    }

    // Assign new variant using weighted selection from theme settings
    const leadMagnetWeight = settings.leadMagnetWeight || 50;
    const bogoWeight = settings.bogoWeight || 50;
    const totalWeight = leadMagnetWeight + bogoWeight;

    // Calculate threshold as a ratio (e.g., 70/30 = 70% chance for A)
    const threshold = leadMagnetWeight / totalWeight;

    const rand = Math.random();
    let variant;
    if (rand < threshold) {
      variant = 'A';
    } else {
      variant = 'B';
    }

    console.log('[ABC Test] Weights - Lead Magnet:', leadMagnetWeight, '%, BOGO:', bogoWeight, '%, Threshold:', (threshold * 100).toFixed(1) + '%');

    // Save to cookie
    setCookie(CONFIG.cookieName, variant, CONFIG.cookieExpiry);
    console.log('[ABC Test] Assigned variant:', variant);

    // Track assignment
    trackEvent('abc_test_assigned', {
      test_variant: CONFIG.variants[variant].name,
      test_variant_label: CONFIG.variants[variant].label
    });

    return variant;
  }

  // ============================================
  // Popup Display Logic
  // ============================================
  function showPopup(variant) {
    const overlay = document.getElementById('abc-popup-overlay');
    const popupA = document.getElementById('popup-variant-a');
    const popupB = document.getElementById('popup-variant-b');

    if (!overlay) return;

    // Hide all first
    popupA.style.display = 'none';
    popupB.style.display = 'none';

    if (variant === 'A') {
      popupA.style.display = 'block';

      // Check for popup image from settings (same as live popup)
      const imageSide = document.getElementById('abc-popup-image-side');
      const leftImage = document.getElementById('abc-popup-left-image');
      const imageToShow = window.samplePopupImageA || window.samplePopupImageB || window.samplePopupImage;

      if (imageToShow && imageSide && leftImage) {
        leftImage.src = imageToShow;
        imageSide.style.display = 'block';
        popupA.classList.add('has-image');
      }

      initLeadMagnetPopup();
    } else if (variant === 'B') {
      popupB.style.display = 'block';
      initBogoPopup();
    } else {
      // Variant C - no popup
      return;
    }

    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Load lazy images only when popup opens
    overlay.querySelectorAll('.abc-lazy-img[data-src]').forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });

    // Track popup view
    trackEvent('abc_test_popup_view', {
      test_variant: CONFIG.variants[variant].name,
      test_variant_label: CONFIG.variants[variant].label
    });
  }

  function closePopup(converted = false) {
    const overlay = document.getElementById('abc-popup-overlay');
    if (!overlay) return;

    overlay.classList.remove('active');
    document.body.style.overflow = '';

    const variant = getCookie(CONFIG.cookieName) || window.abcTestVariant;

    if (!converted && variant && CONFIG.variants[variant]) {
      trackEvent('abc_test_popup_dismissed', {
        test_variant: CONFIG.variants[variant].name,
        test_variant_label: CONFIG.variants[variant].label
      });
    }
  }

  // ============================================
  // Lead Magnet (Variant A) Logic - Matches Live Popup
  // ============================================
  function initLeadMagnetPopup() {
    const popup = document.getElementById('popup-variant-a');
    const variantBtns = popup.querySelectorAll('.abc-popup__variant');
    const selectedCountEl = document.getElementById('selected-count-a');
    const submitBtn = document.getElementById('lead-magnet-submit');
    const errorEl = document.getElementById('lead-magnet-error');
    const closeBtn = popup.querySelector('.abc-popup__close');
    const titleEl = document.getElementById('lead-magnet-title');
    const subtitleEl = document.getElementById('lead-magnet-subtitle');
    const disclaimerEl = document.getElementById('lead-magnet-disclaimer');

    // Apply customizable text from settings
    const leadSettings = window.leadMagnetSettings || {};
    if (leadSettings.title && titleEl) titleEl.textContent = leadSettings.title;
    if (leadSettings.subtitle && subtitleEl) subtitleEl.textContent = leadSettings.subtitle;
    if (leadSettings.buttonText && submitBtn) submitBtn.textContent = leadSettings.buttonText;
    if (leadSettings.disclaimer && disclaimerEl) disclaimerEl.textContent = leadSettings.disclaimer;

    const MAX_SELECTIONS = 3;
    let selectedVariants = [];

    // Close button
    closeBtn.addEventListener('click', () => closePopup(false));

    // Overlay click to close
    document.getElementById('abc-popup-overlay').addEventListener('click', function(e) {
      if (e.target === this) closePopup(false);
    });

    // Variant selection
    variantBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const variantId = this.dataset.variantId;

        if (this.classList.contains('selected')) {
          // Deselect
          this.classList.remove('selected');
          selectedVariants = selectedVariants.filter(id => id !== variantId);
        } else if (selectedVariants.length < MAX_SELECTIONS) {
          // Select
          this.classList.add('selected');
          selectedVariants.push(variantId);

          // Track individual scent selection to Google Sheet
          if (typeof MburTracker !== 'undefined') {
            MburTracker.trackSampleSelection(this.dataset.variantTitle);
          }
        }

        // Update count
        selectedCountEl.textContent = selectedVariants.length;

        // Update disabled state on non-selected buttons
        variantBtns.forEach(b => {
          if (!b.classList.contains('selected')) {
            if (selectedVariants.length >= MAX_SELECTIONS) {
              b.classList.add('disabled');
            } else {
              b.classList.remove('disabled');
            }
          }
        });

        // Enable submit when 3 selected
        submitBtn.disabled = selectedVariants.length !== MAX_SELECTIONS;
      });
    });

    // Submit handler - Optimized for speed with success screen
    submitBtn.addEventListener('click', function() {
      if (submitBtn.disabled) return;

      errorEl.textContent = '';
      submitBtn.disabled = true;

      // Build checkout URL with discount
      const checkoutUrl = '/checkout?discount=' + CONFIG.sampleDiscountCode;

      // Preload checkout page immediately
      const preloadLink = document.createElement('link');
      preloadLink.rel = 'prefetch';
      preloadLink.href = checkoutUrl;
      document.head.appendChild(preloadLink);

      // Get selected scent names for success screen
      const selectedScentNames = [];
      variantBtns.forEach(btn => {
        if (btn.classList.contains('selected')) {
          selectedScentNames.push(btn.dataset.variantTitle);
        }
      });

      // =============================================
      // FIRE SAMPLE_REQUEST EVENT TO META PIXEL
      // This replaces the Add to Cart events for samples
      // =============================================
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'Sample_Request', {
          content_name: 'Free Sample Pack',
          content_type: 'product',
          num_items: selectedScentNames.length,
          scents_selected: selectedScentNames.join(', '),
          test_variant: 'lead_magnet'
        });
        console.log('Meta Pixel: Sample_Request event fired', { scents: selectedScentNames });
      }

      // =============================================
      // FIRE SAMPLE_REQUEST EVENT TO GA4
      // =============================================
      if (typeof gtag !== 'undefined') {
        gtag('event', 'sample_request', {
          'event_category': 'Lead Generation',
          'num_items': selectedScentNames.length,
          'scents_selected': selectedScentNames.join(', ')
        });
        console.log('GA4: sample_request event fired', { scents: selectedScentNames });
      }

      // =============================================
      // TRACK SAMPLE REQUEST TO GOOGLE SHEET
      // =============================================
      if (typeof MburTracker !== 'undefined') {
        MburTracker.trackSampleRequest(selectedScentNames);
        console.log('MburTracker: sample_request sent to Google Sheet', { scents: selectedScentNames });
      }

      // Set flag to prevent Add to Cart events from firing for sample popup
      // This flag is checked in ga4-ecommerce-events.liquid and tracking-pixels.liquid
      window.isSamplePopupCartAdd = true;

      // Animate button to green first
      submitBtn.classList.add('is-success');
      submitBtn.textContent = 'Great choices!';

      // After button animation, show success screen
      setTimeout(() => {
        const successScreen = document.getElementById('lead-magnet-success');
        const scentList = document.getElementById('success-scent-list');
        const progressFill = document.getElementById('progress-fill');
        const successSettings = window.successPopupSettings || {};

        // Apply success settings from Theme Editor
        const successTitleEl = document.getElementById('success-title');
        const successMessageEl = document.getElementById('success-message');
        const successIconContainer = document.getElementById('success-icon-container');

        if (successSettings.title && successTitleEl) {
          successTitleEl.textContent = successSettings.title;
        }
        if (successSettings.message && successMessageEl) {
          successMessageEl.textContent = successSettings.message;
        }
        if (successSettings.image && successIconContainer) {
          successIconContainer.innerHTML = `<img src="${successSettings.image}" alt="Success" style="max-width: 120px; max-height: 120px; border-radius: 8px;">`;
        }

        // Hide the selection UI elements
        document.querySelector('#popup-variant-a .abc-popup__title').style.display = 'none';
        document.querySelector('#popup-variant-a .abc-popup__subtitle').style.display = 'none';
        document.getElementById('variant-buttons-a').style.display = 'none';
        document.querySelector('#popup-variant-a .abc-popup__selected-count').style.display = 'none';
        submitBtn.style.display = 'none';
        errorEl.style.display = 'none';

        // Populate and show success screen
        scentList.innerHTML = selectedScentNames.map(name => `<li>${name}</li>`).join('');
        successScreen.style.display = 'block';

        // Animate progress bar - use settings delay or default to 4 seconds
        const progressDuration = successSettings.autoRedirectDelay || 4000;
        const progressStart = Date.now();

        function animateProgress() {
          const elapsed = Date.now() - progressStart;
          const progress = Math.min((elapsed / progressDuration) * 100, 100);
          progressFill.style.width = progress + '%';

          if (progress < 100) {
            requestAnimationFrame(animateProgress);
          }
        }

        requestAnimationFrame(animateProgress);
      }, 600);

      // Track conversion immediately
      trackEvent('abc_test_popup_conversion', {
        test_variant: CONFIG.variants['A'].name,
        test_variant_label: CONFIG.variants['A'].label,
        conversion_type: 'lead_magnet',
        items_selected: selectedVariants.length,
        scents_selected: selectedScentNames.join(', ')
      });

      // Add to cart
      const items = selectedVariants.map(id => ({
        id: parseInt(id),
        quantity: 1
      }));

      // Get redirect delay from settings (convert ms to appropriate timeout)
      const successSettings = window.successPopupSettings || {};
      const redirectDelay = successSettings.autoRedirectDelay || 2000;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }).then(() => {
        // Redirect after showing success screen based on settings
        setTimeout(() => {
          window.location.href = checkoutUrl;
        }, redirectDelay);
      }).catch((error) => {
        console.error('Cart error:', error);
        setTimeout(() => {
          window.location.href = checkoutUrl;
        }, redirectDelay);
      });

      // Fallback: Redirect after delay + 1 second even if fetch is slow
      setTimeout(() => {
        window.location.href = checkoutUrl;
      }, redirectDelay + 1000);
    });
  }

  // ============================================
  // BOGO (Variant B) Logic
  // ============================================
  function initBogoPopup() {
    const popup = document.getElementById('popup-variant-b');
    const closeBtn = popup.querySelector('.abc-popup__close');
    const shopNowBtn = document.getElementById('bogo-shop-now');
    const copyBtn = document.getElementById('copy-bogo-code');

    // Apply settings from Theme Editor
    const settings = window.bogoPopupSettings || {};
    if (settings.badge) document.getElementById('bogo-badge').textContent = settings.badge;
    if (settings.title) document.getElementById('bogo-title').textContent = settings.title;
    if (settings.subtitle) document.getElementById('bogo-subtitle').textContent = settings.subtitle;
    if (settings.codeLabel) document.getElementById('bogo-code-label').textContent = settings.codeLabel;
    if (settings.discountCode) {
      document.getElementById('bogo-code').textContent = settings.discountCode;
      CONFIG.bogoDiscountCode = settings.discountCode;
    }
    if (settings.buttonText) shopNowBtn.textContent = settings.buttonText;
    if (settings.terms) document.getElementById('bogo-terms').textContent = settings.terms;

    // Close button
    closeBtn.addEventListener('click', () => closePopup(false));

    // Overlay click to close
    document.getElementById('abc-popup-overlay').addEventListener('click', function(e) {
      if (e.target === this) closePopup(false);
    });

    // Copy code
    copyBtn.addEventListener('click', async function() {
      const copyOverlay = document.getElementById('copy-success-overlay');

      // Do the copy
      try {
        await navigator.clipboard.writeText(CONFIG.bogoDiscountCode);
      } catch (e) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = CONFIG.bogoDiscountCode;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      // Show copy success overlay
      copyBtn.classList.add('copied');
      if (copyOverlay) {
        copyOverlay.style.display = 'flex';
      }

      // Track code copy
      trackEvent('abc_test_code_copied', {
        test_variant: CONFIG.variants['B'].name,
        discount_code: CONFIG.bogoDiscountCode
      });

      // Set BOGO banner flag so it shows in cart later
      sessionStorage.setItem('bogo_banner_shown', 'true');
      sessionStorage.setItem('bogo_discount_code', CONFIG.bogoDiscountCode);

      // Hide overlay after 2 seconds and close popup
      setTimeout(() => {
        if (copyOverlay) {
          copyOverlay.style.display = 'none';
        }
        copyBtn.classList.remove('copied');
        closePopup(true);
      }, 2000);
    });

    // Shop Now button
    shopNowBtn.addEventListener('click', function() {
      // Track conversion
      trackEvent('abc_test_popup_conversion', {
        test_variant: CONFIG.variants['B'].name,
        test_variant_label: CONFIG.variants['B'].label,
        conversion_type: 'bogo_shop_now',
        discount_code: CONFIG.bogoDiscountCode
      });

      closePopup(true);

      // Store flags to show BOGO banner and open cart on page load
      sessionStorage.setItem('bogo_banner_shown', 'true');
      sessionStorage.setItem('bogo_discount_code', CONFIG.bogoDiscountCode);
      sessionStorage.setItem('open_cart_on_load', 'true');

      // Navigate to collections with discount code
      const buttonUrl = (settings.buttonUrl || '/collections/all');
      window.location.href = buttonUrl + (buttonUrl.includes('?') ? '&' : '?') + 'discount=' + CONFIG.bogoDiscountCode;
    });
  }

  // ============================================
  // Initialize Test
  // ============================================
  const POPUP_SHOWN_KEY = 'abc_popup_shown_this_session';
  const SHOW_PERCENTAGE_KEY = 'abc_popup_show_eligible';

  async function init() {
    // Check if A/B/C test is enabled in theme settings
    const settings = window.abcTestSettings || { enabled: true, showPercentage: 100 };

    if (!settings.enabled) {
      console.log('[ABC Test] Disabled in theme settings');
      return;
    }

    // Check show percentage (only decide once per session)
    let isEligibleToShow = sessionStorage.getItem(SHOW_PERCENTAGE_KEY);
    if (isEligibleToShow === null) {
      // First visit this session - roll the dice
      const roll = Math.random() * 100;
      isEligibleToShow = roll < settings.showPercentage;
      sessionStorage.setItem(SHOW_PERCENTAGE_KEY, isEligibleToShow ? 'true' : 'false');
      console.log('[ABC Test] Show percentage roll:', roll.toFixed(1), '/', settings.showPercentage, '% - Eligible:', isEligibleToShow);
    } else {
      isEligibleToShow = isEligibleToShow === 'true';
    }

    if (!isEligibleToShow) {
      console.log('[ABC Test] Not eligible to see popup this session (show percentage)');
      return;
    }

    // Skip if on challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    // Check for internal traffic
    if (await isInternalTraffic()) {
      return;
    }

    // Assign variant
    const variant = assignVariant();

    // Store for debugging
    window.abcTestVariant = variant;
    window.abcTestConfig = CONFIG.variants[variant];
    console.log('[ABC Test] Active variant:', variant, CONFIG.variants[variant]);

    // Check if popup was already shown this session
    const popupAlreadyShown = sessionStorage.getItem(POPUP_SHOWN_KEY);

    // Show popup after delay (for variants A and B only)
    if (variant !== 'C') {
      if (!popupAlreadyShown) {
        setTimeout(() => {
          showPopup(variant);
          // Mark popup as shown for this session
          sessionStorage.setItem(POPUP_SHOWN_KEY, 'true');
        }, CONFIG.popupDelay);
      } else {
        console.log('[ABC Test] Popup already shown this session, skipping');
      }
    } else {
      // Track control group page view (only once per session)
      if (!popupAlreadyShown) {
        trackEvent('abc_test_control_pageview', {
          test_variant: CONFIG.variants['C'].name,
          test_variant_label: CONFIG.variants['C'].label
        });
        sessionStorage.setItem(POPUP_SHOWN_KEY, 'true');
      }
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.showPopup = showPopup;
})();
